import { TripDetailsViewModel } from '@bhtp-client-web/component';
import { PurchaseData, Country } from './../../shared/models';

export class TripDetails extends TripDetailsViewModel {
    public static fromPurchaseData(source: PurchaseData): TripDetails {
        let target: TripDetails = new TripDetails();

        // Trip Dates
        target.departureDate = source.departureDate;
        target.returnDate = source.returnDate;

        // Trip Destination
        if (source.destinationCountry) {
            target.destination = source.destinationCountry.name || source.destination;
            target.destinationCountry = source.destinationCountry.isoCode2;
        } else {
            target.destination = source.destination;
        }
        target.destinationCity = source.destinationCity;
        target.destinationState = source.destinationState;

        // Trip Suppliers

        // prefills the airline with first flight information if there are any
        // checking for null and undefined because we want to handle for empty string
        if ((source.airline === null || source.airline === undefined) && (source.flights && source.flights.length > 0 && source.flights[0].airline)) {
            target.airline = source.flights[0].airline.name;
        } else {
            target.airline = source.airline;
        }

        if ((target.airline === null || target.airline === undefined) || target.airline === '') {
            target.airlineNotProvided = true;
        } else {
            target.airlineNotProvided = false;
        }

        target.carRentalCompany = source.carRentalCompany;
        target.cruise = source.cruiseLine;
        target.hotel = source.hotel;
        target.rentalCompany = source.rentalCompany;
        target.tourOperator = source.tourOperator;

        return target;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/trip-details.model.ts